<section class="cui-dialog about-dialog">
  <header class="cui-dialog__header">
    <h1>About Hephaestus</h1>
    <cui-dialog-close-button />
  </header>

  <div class="cui-dialog__content">
    <a
      class="company-link"
      href="https://tensor-solutions.com/"
      target="_blank"
      rel="noopener noreferrer">
      <svg class="ts-logo" aria-hidden="true" />
      <span>Tensor AI Solutions</span>
    </a>

    <div class="link-group">
      <h2>Links</h2>
      <button cuiButton variant="plain" type="button" (click)="openTerms()">
        Terms of Service
      </button>
    </div>

    <div class="link-group">
      <h2>Get in touch</h2>
      <a
        cuiButton
        variant="plain"
        href="https://www.linkedin.com/company/tensor-ai-solutions/"
        target="_blank"
        rel="noopener noreferrer">
        <span class="material-symbols-outlined" aria-hidden="true">group</span>
        Find us on LinkedIn
      </a>
      <a cuiButton variant="plain" href="mailto:info@tensor-solutions.com">
        <span class="material-symbols-outlined" aria-hidden="true">mail</span>
        Contact us
      </a>
      <a cuiButton variant="plain" href="tel:+4915255958173">
        <span class="material-symbols-outlined" aria-hidden="true">call</span>
        Call us
      </a>
      <a cuiButton variant="plain" [href]="supportHref">
        <span class="material-symbols-outlined" aria-hidden="true">contact_support</span>
        Need help? Contact Support
      </a>
    </div>
  </div>

  <footer class="cui-dialog__footer">© {{ currentYear }} | Tensor AI Solutions</footer>
</section>
